import * as Yup from 'yup';
import { HEIGHT_MEASUREMENT } from 'productTemplate/enums/fitFeedback';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.utils.getFitFeedbackFormValidationSchema';

export const getFitFeedbackFormValidationSchema = (isSneakers, heightMeasurement) => {
  if (isSneakers) {
    return Yup.object().shape({
      sneakersSizePurchased: Yup.string()
        .nullable()
        .required(t(`${TP}.sneakersSizePurchasedRequired`, 'Please select a size')),
      sneakersFit: Yup.string()
        .nullable()
        .required(t(`${TP}.sneakersFitRequired`, 'Please select a fit option')),
    });
  }

  let heightSchema = {};

  if (heightMeasurement === HEIGHT_MEASUREMENT.FT) {
    heightSchema = {
      heightFeet: Yup.number()
        .typeError(t(`${TP}.heightFeetTypeError`, 'Please provide a valid height'))
        .integer(t(`${TP}.heightFeetInteger`, 'Please provide a valid height'))
        .required(t(`${TP}.heightFeetRequired`, 'Please provide a valid height'))
        .positive(t(`${TP}.heightFeetPositive`, 'Please provide a valid height'))
        .max(8, t(`${TP}.heightFeetMax`, 'Please provide a valid height')),
      heightInches: Yup.number()
        .typeError(t(`${TP}.heightInchesTypeError`, 'Please provide a valid height'))
        .positive(t(`${TP}.heightInchesPositive`, 'Please provide a valid height'))
        .integer(t(`${TP}.heightInchesInteger`, 'Please provide a valid height'))
        .max(11, t(`${TP}.heightInchesMax`, 'Please provide a valid height')),
    };
  }

  if (heightMeasurement === HEIGHT_MEASUREMENT.CM) {
    heightSchema = {
      heightCm: Yup.number()
        .typeError(t(`${TP}.heightCmTypeError`, 'Please provide a valid height'))
        .integer(t(`${TP}.heightCmInteger`, 'Please provide a valid height'))
        .required(t(`${TP}.heightCmRequired`, 'Please provide a valid height'))
        .positive(t(`${TP}.heightCmPositive`, 'Please provide a valid height'))
        .max(244, t(`${TP}.heightCmMax`, 'Please provide a valid height')),
    };
  }

  return Yup.object().shape({
    ...heightSchema,
    bodyShape: Yup.string()
      .nullable()
      .required(t(`${TP}.bodyShapeRequired`, 'Please select a body size')),
    style: Yup.string()
      .nullable()
      .required(t(`${TP}.styleRequired`, 'Please select a style')),
    sizePurchased: Yup.string()
      .nullable()
      .required(t(`${TP}.sizePurchasedRequired`, 'Please select a size')),
    sizeFit: Yup.string()
      .nullable()
      .required(t(`${TP}.sizeFitRequired`, 'Please select a size')),
  });
};
